import { useModal } from "@ebay/nice-modal-react";
import { useState } from "react";

import Banner from "ds/components/Banner";
import Box from "ds/components/Box";
import Button from "ds/components/Button";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerFooter from "ds/components/Drawer/Footer";
import DrawerFooterActions from "ds/components/Drawer/FooterActions";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCancelButton from "ds/components/DrawerNew/CancelButton";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerForm from "ds/components/DrawerNew/Form";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import Tile from "ds/components/Tile";
import { ForceApplyMode } from "types/generated";

type StackRunForceApplyDrawerProps = {
  onTrigger: (mode: ForceApplyMode) => void;
};

const StackRunForceApplyDrawer = createDrawer(({ onTrigger }: StackRunForceApplyDrawerProps) => {
  const [mode, setMode] = useState<ForceApplyMode>(ForceApplyMode.Single);

  const drawer = useModal();

  const handleTrigger = () => {
    onTrigger(mode);
    drawer.hide();
  };

  return (
    <DrawerForm isDirty={false}>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="Force apply" />
        <DrawerCloseIcon />
      </DrawerHeader>
      <DrawerBody>
        <Banner variant="warning" margin="0 0 x-large 0">
          Force apply will apply the run even when the delta is zero.
        </Banner>
        <Box gap="large">
          <Tile
            title="This run only"
            description="Force apply this run only. Dependent stacks will not be affected."
            indicator="radio"
            selected={mode === ForceApplyMode.Single}
            onClick={() => setMode(ForceApplyMode.Single)}
          />
          <Tile
            title="Cascade to dependents"
            description="Force apply this run and propagate to all triggered dependent stacks."
            indicator="radio"
            selected={mode === ForceApplyMode.Cascade}
            onClick={() => setMode(ForceApplyMode.Cascade)}
          />
        </Box>
      </DrawerBody>
      <DrawerFooter>
        <DrawerFooterActions>
          <DrawerCancelButton />
          <Button variant="primary" onPress={handleTrigger}>
            Trigger
          </Button>
        </DrawerFooterActions>
      </DrawerFooter>
    </DrawerForm>
  );
});

export const showStackRunForceApplyDrawer = createDrawerTrigger(StackRunForceApplyDrawer);
